import { TabsProps } from 'antd/lib'
import styles from './HeaderTabs.module.less'

type HeaderTabBarProps = {
    items: TabsProps['items']
    activeKey?: string
    onTabClick: (key: string) => void
}

export const HeaderTabBar: React.FC<HeaderTabBarProps> = (props: HeaderTabBarProps) => {
    return (
        <div className={styles['header-tab-bar']}>
            {props.items?.map(item => {
                const isActive = item.key === props.activeKey
                return (
                    <button
                        onClick={() => props.onTabClick(item.key)}
                        type="button"
                        key={item.key}
                        className={
                            styles['header-tab-pane'] + ' ' + (isActive ? styles['selected'] : '')
                        }
                    >
                        {item.label}
                    </button>
                )
            })}
        </div>
    )
}
